import type { CheckableItemProps } from './const';
import { cn } from '@utils';
import { forwardRef, useState } from 'react';
import './index.less';

function CheckableItem(props: CheckableItemProps, ref: React.Ref<HTMLSpanElement>) {
  const {
    children,
    className,
    style,
    checkable,
    checked: checkedProp,
    defaultChecked,
    onCheck,
    onClick,
  } = props;

  const [internalChecked, setInternalChecked] = useState(defaultChecked ?? false);
  const isControlled = checkedProp !== undefined;
  const checked = isControlled ? checkedProp : internalChecked;

  const handleClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    if (checkable) {
      const newChecked = !checked;
      if (!isControlled) {
        setInternalChecked(newChecked);
      }
      onCheck?.(newChecked);
    }
    onClick?.(e);
  };

  return (
    <span
      ref={ref}
      className={cn(
        'wg-checkable-item',
        {
          'wg-checkable-item--checkable': checkable,
          'wg-checkable-item--checked': checked,
        },
        className,
      )}
      style={style}
      onClick={handleClick}
    >
      {children}
    </span>
  );
}

const CheckableItemComponent = forwardRef<HTMLSpanElement, CheckableItemProps>(CheckableItem);
CheckableItemComponent.displayName = 'CheckableItem';

export default CheckableItemComponent;

export type { CheckableItemProps };
